module.exports = __webpack_public_path__ + "img/dsci0050.b2efba80.jpg";